import React from "react";

const Authorizations = ({
  onClickFn = () => {},
  width = "23",
  height = "20",
  fill = "currentColor",
}) => {
  return (
    <svg
      className="cursor-pointer"
      onClick={onClickFn}
      width={width}
      height={height}
      viewBox="0 0 30 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3270_51)">
<path d="M10.5 12C12.0913 12 13.6174 11.3679 14.7426 10.2426C15.8679 9.11742 16.5 7.5913 16.5 6C16.5 4.4087 15.8679 2.88258 14.7426 1.75736C13.6174 0.632141 12.0913 0 10.5 0C8.9087 0 7.38258 0.632141 6.25736 1.75736C5.13214 2.88258 4.5 4.4087 4.5 6C4.5 7.5913 5.13214 9.11742 6.25736 10.2426C7.38258 11.3679 8.9087 12 10.5 12ZM8.35781 14.25C3.74063 14.25 0 17.9906 0 22.6078C0 23.3766 0.623438 24 1.39219 24H18.4031C18.15 23.5594 18 23.0484 18 22.5V16.5C18 16.4016 18.0047 16.3031 18.0141 16.2047C16.5609 14.9859 14.6859 14.25 12.6422 14.25H8.35781ZM24.75 11.25C25.5797 11.25 26.25 11.9203 26.25 12.75V15H23.25V12.75C23.25 11.9203 23.9203 11.25 24.75 11.25ZM21 12.75V15C20.1703 15 19.5 15.6703 19.5 16.5V22.5C19.5 23.3297 20.1703 24 21 24H28.5C29.3297 24 30 23.3297 30 22.5V16.5C30 15.6703 29.3297 15 28.5 15V12.75C28.5 10.6781 26.8219 9 24.75 9C22.6781 9 21 10.6781 21 12.75Z" fill={fill}/>
</g>
<defs>
<clipPath id="clip0_3270_51">
<path d="M0 0H30V24H0V0Z" fill={fill}/>
</clipPath>
</defs>
    </svg>
  );
};

export default Authorizations;